
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5a5 5 0 015-5h20a5 5 0 015 5v20a5 5 0 01-5 5H5a5 5 0 01-5-5V5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.318 21.818a.682.682 0 101.364 0v-6.136h6.136a.682.682 0 100-1.364h-6.136V8.182a.682.682 0 10-1.364 0v6.136H8.182a.682.682 0 100 1.364h6.136v6.136z","fill":"#6E88F3"}})])
          )
        }
      }
    